export default "__VITE_ASSET__3Uw3XUngRQNUvCPRrDEOAQ__"